import * as React from 'react'

const MenuItem = ({ name, checked, handleClick }: { name: string; checked: boolean; handleClick: () => void }) => (
  <div className='pt1 pb1 cursor--pointer'>
    <input type='checkbox' checked={checked} id={`checkbox-${name}`} onChange={handleClick} />
    <label htmlFor={`checkbox-${name}`} className='ml1 font-dark-grey cursor--pointer'>
      {name}
    </label>
  </div>
)

export default MenuItem



// WEBPACK FOOTER //
// ./src/components/ui/MenuItem.tsx